export function legalFileUrl(path, apiUrl = typeof window !== 'undefined' ? window.__env?.api?.url : null) {
    // During local development the portal and the PHP public directory have different origins.
    try { return apiUrl ? new URL(path, apiUrl).href : path; } catch (_) { return path; }
}

export const LEGAL_DOCUMENTS = [
    {key: 'terms', version: '2026-02-01-v3', title: 'Általános szerződési feltételek', url: legalFileUrl('/legal/terms-20260201-v3.pdf')},
    {key: 'gdpr', version: '2026-04-09', title: 'Adatkezelési tájékoztató', url: legalFileUrl('/legal/privacy-20260409.pdf')},
];

export function legalPayload(values, documents = LEGAL_DOCUMENTS) {
    return {...values, legal_versions: Object.fromEntries(documents.map(doc => [doc.key, doc.version]))};
}

export function missingLegalDocuments(status, fallback = LEGAL_DOCUMENTS) {
    return (status?.documents || fallback).filter(document => !document.accepted);
}
